import { BrowserRouter } from 'react-router-dom'
import { Provider } from '@/components/ui/provider'

import './App.css'
import AuthRouter from './routes/auth-router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { isAxiosError } from 'axios'
import { Toaster } from '@/components/ui/Toaster.tsx'
import { BrandProvider } from '@/context/brand-context'

const MAX_RETRIES = 6
const HTTP_STATUS_TO_NOT_RETRY = [400, 401, 403, 404, 409]

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (failureCount > MAX_RETRIES) {
          return false
        }

        if (
          isAxiosError(error) &&
          HTTP_STATUS_TO_NOT_RETRY.includes(error.response?.status ?? 0)
        ) {
          console.log(`Aborting retry due to ${error.response?.status} status`)
          return false
        }

        return true
      }
    }
  }
})

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Provider>
        <BrandProvider>
          <BrowserRouter>
            <AuthRouter />
            <Toaster />
          </BrowserRouter>
        </BrandProvider>
      </Provider>
    </QueryClientProvider>
  )
}

export default App
